/* ============================================================
   VYARA® — HOME JS  (assets/vyara-home.js)
   Loaded only on homepage via sections/vyara-home.liquid
   ============================================================ */

(function () {
  'use strict';

  var container = document.getElementById('vyara-speedlines');
  if (!container) return;

  function makeSpeedLine() {
    var s = document.createElement('div');
    s.className = 'vyara-speed-lines__line';
    s.style.width             = (80 + Math.random() * 200) + 'px';
    s.style.top               = Math.random() * 100 + '%';
    s.style.animationDuration = (1.5 + Math.random() * 2) + 's';
    s.style.animationDelay    = (Math.random() * 2) + 's';
    container.appendChild(s);
    setTimeout(function () { s.remove(); }, 4500);
  }

  setInterval(makeSpeedLine, 300);

})();
